import { combineReducers } from "redux";
import { RESET_REDUX_APP_STATE } from "../actions/types";

import fetchKeywordReducer from "./fetchKeywordReducer";
import clinicalTrialReducer from "./clinicalTrialReducer";
import signupReducer from "./signupReducer";
import loginReducer from "./loginReducer";
import authReducer from "./authReducer";
import nonUserReducer from "./nonUserReducer";
import globalKeywordReducer from "./globalKeywordReducer";
import collaboratorChartReducer from "./collaboratorChartReducer";
import expertReducer from "./expertReducer";
import geographyReducer from "./geographyReducer";
import loadingReducer from "./loadingReducer";
import authorProfileTabReducer from "./authorProfileTabReducer";
import userReducer from "./userReducer";
import UserReducer from "./UserReducer/UserReducer";

/**
 * NEW REDUCERS
 */
import search_reducer from "./search_reducer";
import clinical_trial_reducer from "./clinical_trial_reducer";
import top_author_reducer from "./top_author_reducer";
import ukReducer from "./ukReducer";
import affiliationsReducer from "./affiliationsReducer";

//new
import ExpertReducer from "./ExpertReducer/ExpertReducer";
import SearchBarReducer from "./SearchBarReducer/SearchBarReducer";
import GlobalReducer from "./GlobalReducer/GlobalReducer";
import RelatedTermsReducer from "./RelatedTermsReducer/RelatedTermsReducer";
import TwitterReducer from "./TwitterReducer/TwitterReducer";
import LocationsReducer from "./LocationReducerNew";
import ExpertUpdateArrayReducer from "./ExpertArrayUpdateReducer/ExpertUpdateArrayReducer";
//location table reducer
import LocationTable from "./LocationReducerNew/LocationTable";

//expert bio collab reducer
import ExpertBioCollabReducer from "./ExpertBioCollab/ExpertBioCollabReducer";

//collan network profile reducer
import CollaboratorNetworkProfileReducer from "./CollaboratorNetworkProfileReducer/CollaboratorNetworkProfileReducer";

//recent searches reducer
import RecentSearchesReducer from "./RecentSearchesReducer/RecentSearchesReducer";

//handle expert reducer
import HandleExpertReducer from "./HandleExpertReducer/HandleExpertReducer";

//peer review reducer
import PeerReviewReducer from "./PeerReviewReducer/PeerReviewReducer";

//Organisation reducer
import OrganisationsReducer from "./OrganisationsReducer/OrganisationsReducer";

//Aff bio reducer
import AffBioReducer from "./AffBioReducer/AffBioReducer";

import ClinicalTrialReducer from "./ClinicalTrialReducer/ClinicalTrialReducer";
import ExpertBioReducer from "./ExpertBioReducer/ExpertBioReducer";
import TopicReducer from "./TopicReducer/TopicReducer";
import CollaboratorNetworkReducer from "./CollaboratorNetworkReducer/CollaboratorNetworkReducer";
import KeywordNetworkReducer from "./KeywordNetworkReducer/KeywordNetworkReducer";
import ProfileSearchReducer from "./ProfileSearchReducer/ProfileSearchReducer";
import AffiliationProfileSearchReducer from "./AffiliationProfileSearchReducer/AffiliationProfileSearchReducer";
import RelatedCorporateReducer from "./RelatedCorporateReducer/RelatedCorporateReducer";
import ExpertMultiSearchReducer from "./ExpertMultiSearchReducer";
import InstituteReducer from "./InstituteReducer/InstituteReducer";
import SenioritySchemaReducer from "./SenioritySchemaReducer/SenioritySchemaReducer";
import SeniorityProfileExpertsReducer from "./SenioritySchemaReducer/SeniorityProfileExpertsReducer";

import SocMedCitationReducer from "./SocMedReducer/SocMedCitationReducer";
import CitationReducer from "./SocMedReducer/CitationReducer";
import LocationTrialReducer from "./LocationsReducer/LocationTrialReducer";

import AffTrilsReducer from "./AffTrialsReducer/AffTrialsReducer";
import GrantsReducer from "./GrantsReducer/GrantsReducer";
import TwitterConfReducer from "./TwitterConfReducer/TwitterConfReducer";

//mld professionals
import MldProfessionals from "./MldProfessinalsNew";
import TrialByIdReducer from "./AffTrialsReducer/TrialByIdReducer";
import MldHome from "./MldHome";

//keyword rank reducer
import KeywordRank from "./ExpertBioReducer/KeywordRankReducer";

//edit expert links
import ExpertEditLinks from "./ExpertEditLinks";

import MldSocialReducer from "./MldSocialReducer/MldSocialReducer";

import MldTrials from "./MldTrials/ClinicalTrialReducer";

import MldConfReducer from "./MldConfReducer/MldConfReducer";
import ShortList from "./MldProfessionals/ShortList";
import MldShortList from "./MldShortList";
import SelectList from "./MldShortList/SelectList";
import MldSelectedList from "./MldSelectedList";
import MldAffiliations from "./MldAffiliations";
import MldNetwork from "./MldProfessionals/Network";
import MldLocationSummary from "./MldLocationsReducer/summary";
import MldLocations from "./MldLocationsReducer";

import MldRemovedShortList from "./MldShortList/removedList";

import KolMapping from "./KolMapping";

//euro network reducer
import EuroNetworkReducer from "./EuroNetworkReducer/EuroNetworkReducer";

import Trials from "./Trials";
import TrialsEndPoints from "./Trials/EndPoints";
import TrialsPhases from "./Trials/Phases";
import MainTrials from "./Trials/MainTrails";
import TrialSites from "./Trials/TrialSites";

//mld trials
import MldTrialsExperts from "./MldTrials/Experts";
import MldTrialsCountry from "./MldTrials/Country";
import MldTrialsInstitutes from "./MldTrials/Institute";

//mld summaries
import MldSummary from "./MldSummary";

//mld professionals
import NiptProfessionals from "./NiptProfessionals";
import NiptProfShortList from "./NiptProfessionals/ShortList";
import NiptShortList from "./NiptShortList";
import NiptSelectList from "./NiptShortList/SelectList";
import NiptSelectedList from "./NiptSelectedList";
import NiptLocations from "./NiptLocations";
import NiptAffiliations from "./NiptAffiliations";
import NipNetwork from "./NiptProfessionals/Network";
import NiptSummary from "./NiptSummary";
import NiptLocationSummary from "./NiptLocations/summary";

//nipt trials
import NiptTrials from "./NiptTrials/ClinicalTrialReducer";
import NiptTrialsExperts from "./NiptTrials/Experts";
import NiptTrialsCountry from "./NiptTrials/Country";
import NiptTrialsInstitutes from "./NiptTrials/Institute";

//related concepts
import RelatedConcepts from "./RelatedConceptsReducer";

import ConceptMapping from "./ConceptMapping";

import RotaApplication from "./RotaApplication";

import PeerReviewer from "./PeerReviewer";
import DirectProfileSearch from "./DirectProfileSearch";

import MldMedicalBodies from "./MldMedicalBodies";

import RotaDoctors from "./RotaDoctors";
import RotaManagementOncall from "./RotaManagement/oncall";
import RotaManagementLeaves from "./RotaManagement/leaves";

// rocket pharma
import RocketDanon from "./RocketPharma/Danon";
import RocketLad from "./RocketPharma/Lad";
import RocketCros from "./RocketPharma/Cros";
import RocketDanonConf from "./RocketPharma/DanonConf";
import RocketDanonMBodies from "./RocketPharma/DanonMBodies";
import RocketLadConf from "./RocketPharma/LadConf";
import RocketLadMBodies from "./RocketPharma/LadMBodies";

import NiptGrants from "./NiptGrants";
import NiptMedicalBodies from "./NiptOtherLinks/MedicalBodies";
import NiptConf from "./NiptOtherLinks/Conf";
import NiptFundingOrg from "./NiptOtherLinks/FundingOrg";

//alacrita
import AlacritaDefinitions from "./Alacrita/Definitions";
import AlacritaTrials from "./Alacrita/Trials";
import AlacritaEpidemiology from "./Alacrita/Epidemiology";
import AlacritaTrialSites from "./Alacrita/TrialSites";

//Ald professionals
import AldProfessionals from "./BlueBird/AldProfessionals";
import AldSocialReducer from "./BlueBird/AldSocialReducer/AldSocialReducer";
import AldTrials from "./BlueBird/AldTrials/ClinicalTrialReducer";
import AldConfReducer from "./BlueBird/AldConfReducer/AldConfReducer";
import AldShortList from "./BlueBird/AldShortList";
import AldSelectedList from "./BlueBird/AldSelectedList";
import AldAffiliations from "./BlueBird/AldAffiliations";
import AldNetwork from "./BlueBird/AldProfessionals/Network";
import AldLocationSummary from "./BlueBird/AldLocationsReducer/summary";
import AldLocations from "./BlueBird/AldLocationsReducer";
import AldRemovedShortList from "./BlueBird/AldShortList/removedList";
import AldTrialsExperts from "./BlueBird/AldTrials/Experts";
import AldTrialsCountry from "./BlueBird/AldTrials/Country";
import AldTrialsInstitutes from "./BlueBird/AldTrials/Institute";
import AldSummary from "./BlueBird/AldSummary";
import AldMedicalBodies from "./BlueBird/AldMedicalBodies";

import AffiliationSearch from "./AffiliationSearch";
import PersonSimilarity from "./PersonSimilarity";

import MldTweetSummary from "./MldTweets/summary";
import MldTweetRelatedUsers from "./MldTweets/relatedUsers";
import MldTweetRelatedTerms from "./MldTweets/relatedTerms";
import MldTweetSentiment from "./MldTweets/sentiment";
import MldTweetUsers from "./MldTweets/users";
import MldTweetHandler from "./MldTweets/hanlder";

import WasProfessionals from "./Was/Experts";
import WasLocations from "./Was/Locations";
import WasAffiliations from "./Was/Affiliations";
import WasNetwork from "./Was/Network";
import WasMedicalBodies from "./Was/MedicalBodies";
import WasConfs from "./Was/Confs";

import WasTrialsExperts from "./Was/Trials/Experts";
import WasTrialsCountry from "./Was/Trials/Country";
import WasTrialsInstitutes from "./Was/Trials/Institute";
import WasTrials from "./Was/Trials/ClinicalTrialReducer";
import WasSummary from "./Was/Summary";
import ErnNetwork from "./ErnNetwork";
import ProfileBasedNetworkReducer from "./CollaboratorNetworkReducer/ProfileBasedNetworkReducer";

/** new nipt reducers */
import NiptappProfessionals from "./Niptapp/Experts";
import NiptappLocations from "./Niptapp/Locations";
import NiptappAffiliations from "./Niptapp/Affiliations";
import NiptappSummary from "./Niptapp/Summary";
import NiptappNetwork from "./Niptapp/Network";

import NiptappTrialsExperts from "./Niptapp/Trials/Experts";
import NiptappTrialsCountry from "./Niptapp/Trials/Country";
import NiptappTrialsInstitutes from "./Niptapp/Trials/Institute";
import NiptappTrials from "./Niptapp/Trials/ClinicalTrialReducer";

import Dashboard from "./Dashboard";
import GeneralDashboard from "./GeneralDashboard";
import GeneralCongresses from "./GeneralCongresses";
import ClassifiedCongresses from "./ClassfiedCongresses";
import GeneralMedicalBodies from "./GeneralMedicalBodies";

import RareDisease from "./RareDisease";

//zogenix
// import ZogenixProfessionals from "./Zogenix/Experts";
// import ZogenixLocations from "./Zogenix/Locations";
// import ZogenixAffiliations from "./Zogenix/Affiliations";
// import ZogenixSummary from "./Zogenix/Summary";
import ZogenixTrialsCountry from "./Zogenix/Trials/Country";
import ZogenixTrialsExperts from "./Zogenix/Trials/Experts";
import ZogenixTrialsInstitutes from "./Zogenix/Trials/Institute";
import ZogenixTrials from "./Zogenix/Trials/ClinicalTrialReducer";
// import ZogenixMedicalBodies from "./Zogenix/MedicalBodies";
// import ZogenixNetwork from "./Zogenix/Network";
// import ZogenixExpertSummary from "./Zogenix/ExpertSummary";
// import ZogenixConf from "./Zogenix/Conferences";
// import ZogenixSpecialtyCentre from "./Zogenix/SpecialtyCentre";
// import ZogenixSocialMedia from "./Zogenix/SocialMedia";

// Spain social-media
import SpainSocialMedia from "./Zogenix/SpainSocialMedia";
import SpainSocialMediaEls from "./Zogenix/SpainSocialMedia/SpainSocialMediaEls";

//Cardio
import CardioProfessionals from "./Cardiologist/Experts";

//covid
import CovidProfessionals from "./Covid/Experts";
import CovidLocations from "./Covid/Locations";
import CovidAffiliations from "./Covid/Affiliations";
import CovidTrialsCountry from "./Covid/Trials/Country";
import CovidTrialsExperts from "./Covid/Trials/Experts";
import CovidTrialsInstitutes from "./Covid/Trials/Institute";
import CovidTrials from "./Covid/Trials/ClinicalTrialReducer";
import CovidNetwork from "./Covid/Network";
import CovidOrgs from "./Covid/Organisations";

//isns
import Isns from "./Isns";

//newborn screening
import NewBornProfessionals from "./NewBorn/Experts";
import NewBornLocations from "./NewBorn/Locations";
import NewBornAffiliations from "./NewBorn/Affiliations";

//patents
import Patents from "./Patents";

//events-network
import EventsNetwork from "./EventsNetwork";
//application
import Application from "./Application";

import PatentsNew from "./PatentsNew";

const appReducer = combineReducers({
  topExperts: search_reducer,
  affiliationsReducer: affiliationsReducer,
  top_clinical_trials: clinical_trial_reducer,
  top_authors: top_author_reducer,
  login: loginReducer,
  allResult: fetchKeywordReducer,
  clinicalTrial: clinicalTrialReducer,
  signup: signupReducer,
  auth: authReducer,
  nonUser: nonUserReducer,
  globalKeyword: globalKeywordReducer,
  collaboratorChart: collaboratorChartReducer,
  expertResult: expertReducer,
  geography: geographyReducer,
  ukResult: ukReducer,
  RelatedCorporates: RelatedCorporateReducer,
  RecentSearches: RecentSearchesReducer,
  UpdatedExperts: ExpertUpdateArrayReducer,
  Experts: ExpertReducer,
  SearchBar: SearchBarReducer,
  Global: GlobalReducer,
  RelatedTerms: RelatedTermsReducer,
  Tweets: TwitterReducer,
  Locations: LocationsReducer,
  LocationTable: LocationTable,
  ClinicalTrials: ClinicalTrialReducer,
  ExpertBio: ExpertBioReducer,
  ExpertCollab: ExpertBioCollabReducer,
  Topic: TopicReducer,
  CollaboratorNetwork: CollaboratorNetworkReducer,
  CollaboratorNetworkProfile: CollaboratorNetworkProfileReducer,
  KeywordNetwork: KeywordNetworkReducer,
  ProfileSuggestions: ProfileSearchReducer,
  SeniorityProfileSuggestions: SeniorityProfileExpertsReducer,
  AffTrialSuggestions: AffTrilsReducer,
  AffiliationProfileSuggestions: AffiliationProfileSearchReducer,
  ExpertMultiSearch: ExpertMultiSearchReducer,
  User: UserReducer,
  HandleExpert: HandleExpertReducer,
  PeerReviewer: PeerReviewReducer,
  Organisations: OrganisationsReducer,
  AffBio: AffBioReducer,
  searchloading: loadingReducer,
  authorProfileTab: authorProfileTabReducer,
  userProfile: userReducer,
  Institute: InstituteReducer,
  Seniority: SenioritySchemaReducer,
  SocMedCitation: SocMedCitationReducer,
  SocialCitation: CitationReducer,
  LocationTrial: LocationTrialReducer,
  Grants: GrantsReducer,
  TwitterConf: TwitterConfReducer,
  MldProfessionals: MldProfessionals,
  TrialSiteID: TrialByIdReducer,
  KeywordRank: KeywordRank,
  ExpertEditLinks: ExpertEditLinks,
  MldSocial: MldSocialReducer,
  MldTrials: MldTrials,
  MldConf: MldConfReducer,
  ShortList: ShortList,
  MldShortList: MldShortList,
  SelectList: SelectList,
  MldSelectedList: MldSelectedList,
  MldAffiliations: MldAffiliations,
  MldNetwork: MldNetwork,
  KolMapping: KolMapping,
  Euro: EuroNetworkReducer,
  Trials: Trials,
  TrialsEndPoints: TrialsEndPoints,
  MainTrials: MainTrials,
  TrialsPhases: TrialsPhases,
  MldTrialsExperts: MldTrialsExperts,
  MldTrialsInstitutes: MldTrialsInstitutes,
  MldTrialsCountry: MldTrialsCountry,
  MldSummary: MldSummary,
  MldLocations: MldLocations,
  MldLocationSummary: MldLocationSummary,
  NiptProfessionals: NiptProfessionals,
  NiptProfShortList: NiptProfShortList,
  NiptShortList: NiptShortList,
  NiptSelectList: NiptSelectList,
  NiptSelectedList: NiptSelectedList,
  NiptLocations: NiptLocations,
  NiptAffiliations: NiptAffiliations,
  NiptGrants: NiptGrants,
  NipNetwork: NipNetwork,
  NiptSummary: NiptSummary,
  NiptLocationSummary: NiptLocationSummary,
  NiptTrials: NiptTrials,
  NiptTrialsExperts: NiptTrialsExperts,
  NiptTrialsCountry: NiptTrialsCountry,
  NiptTrialsInstitutes: NiptTrialsInstitutes,
  RelatedConcepts: RelatedConcepts,
  MldRemovedShortList: MldRemovedShortList,
  ConceptMapping: ConceptMapping,
  RotaApplication: RotaApplication,
  PeerReviewer: PeerReviewer,
  DirectProfileSearch: DirectProfileSearch,
  TrialSites: TrialSites,
  MldMedicalBodies: MldMedicalBodies,
  RotaDoctors: RotaDoctors,
  RotaManagementOncall: RotaManagementOncall,
  RotaManagementLeaves: RotaManagementLeaves,
  NiptMedicalBodies: NiptMedicalBodies,
  NiptFundingOrg: NiptFundingOrg,
  NiptConf: NiptConf,
  AlacritaDefinitions: AlacritaDefinitions,
  AlacritaTrials: AlacritaTrials,
  AlacritaEpidemiology: AlacritaEpidemiology,
  AlacritaTrialSites: AlacritaTrialSites,
  AldProfessionals: AldProfessionals,
  AldSocial: AldSocialReducer,
  AldTrials: AldTrials,
  AldConf: AldConfReducer,
  AldShortList: AldShortList,
  AldSelectedList: AldSelectedList,
  AldAffiliations: AldAffiliations,
  AldNetwork: AldNetwork,
  AldTrialsExperts: AldTrialsExperts,
  AldTrialsInstitutes: AldTrialsInstitutes,
  AldTrialsCountry: AldTrialsCountry,
  AldSummary: AldSummary,
  AldLocations: AldLocations,
  AldLocationSummary: AldLocationSummary,
  AldRemovedShortList: AldRemovedShortList,
  AldMedicalBodies: AldMedicalBodies,
  RocketDanon: RocketDanon,
  RocketLad: RocketLad,
  RocketCros: RocketCros,
  RocketDanonConf,
  RocketDanonMBodies,
  RocketLadConf,
  RocketLadMBodies,
  AffiliationSearch,
  PersonSimilarity,
  MldHome,
  MldTweetSummary,
  MldTweetRelatedTerms,
  MldTweetRelatedUsers,
  MldTweetSentiment,
  MldTweetUsers,
  MldTweetHandler,
  WasProfessionals,
  WasLocations,
  WasAffiliations,
  WasNetwork,
  WasMedicalBodies,
  WasConfs,
  WasTrials,
  WasTrialsCountry,
  WasTrialsExperts,
  WasTrialsInstitutes,
  WasSummary,
  ErnNetwork,
  ProfileBasedNetworkReducer,
  NiptappAffiliations,
  NiptappLocations,
  NiptappProfessionals,
  NiptappSummary,
  NiptappNetwork,
  NiptappTrialsExperts,
  NiptappTrialsCountry,
  NiptappTrialsInstitutes,
  NiptappTrials,
  Dashboard,
  GeneralDashboard,
  GeneralCongresses,
  ClassifiedCongresses,
  GeneralMedicalBodies,
  RareDisease,
  // ZogenixProfessionals,
  // ZogenixExpertSummary,
  // ZogenixConf,
  // ZogenixLocations,
  // ZogenixAffiliations,
  // ZogenixSummary,
  ZogenixTrialsCountry,
  ZogenixTrialsExperts,
  ZogenixTrialsInstitutes,
  ZogenixTrials,
  SpainSocialMedia,
  SpainSocialMediaEls,
  // ZogenixMedicalBodies,
  // ZogenixNetwork,
  // ZogenixSocialMedia,
  Isns,
  CovidProfessionals,
  CovidLocations,
  CovidAffiliations,
  CovidTrialsCountry,
  CovidTrialsExperts,
  CovidTrialsInstitutes,
  CovidTrials,
  CovidNetwork,
  CovidOrgs,
  CardioProfessionals,
  NewBornProfessionals,
  NewBornAffiliations,
  NewBornLocations,
  // ZogenixSpecialtyCentre,
  Patents,
  EventsNetwork,
  Application,
  PatentsNew
});

const resetAppReducers = {
  Application: undefined,
  // ZogenixProfessionals: undefined,
  ZogenixTrialsCountry: undefined,
  ZogenixTrialsExperts: undefined,
  ZogenixTrialsInstitutes: undefined,
  ZogenixTrials: undefined,
  // ZogenixSpecialtyCentre: undefined,
  // ZogenixExpertSummary: undefined,
  // ZogenixConf: undefined,
  // ZogenixLocations: undefined,
  // ZogenixAffiliations: undefined,
  // ZogenixSummary: undefined,
  // ZogenixMedicalBodies: undefined,
  // ZogenixNetwork: undefined,
  // ZogenixSocialMedia: undefined,
};

const rootReducer = (state, action) => {
  switch (action.type) {
    case RESET_REDUX_APP_STATE:
      state = { ...state, ...resetAppReducers };
      break;

    default:
      state = state;
  }

  return appReducer(state, action);
};

export default rootReducer;
